<template>
  <div
    v-if="!toggle"
    :style="{ backgroundColor: color }"
    class="label__status LKRoadmapsFeedLabelStatus"
  >
    <span class="text-sm-bold mod--roadmap-label" v-text="label" />
  </div>

  <div
    v-else
    :style="{ backgroundColor: color }"
    class="label__status-active LKRoadmapsFeedLabelStatus"
    @click="isActive = !isActive"
  >
    <div class="label-active-up">
      <div class="text-sm-bold mod--roadmap-label" v-text="label" />

      <div class="label-active-arrow">
        <IconToggle
          :active="isActive"
          :loading="isLoading"
          style="margin: 0;"
          class="drop__arrow LKRoadmapsFeedLabelStatus__icon-toggle"
        />
      </div>
    </div>

    <div
      :class="{ 'is-active': isActive }"
      class="label-active-down LKRoadmapsFeedLabelStatus__bottom"
      @click.stop
    >
      <a
        v-for="item in labelList"
        :key="item.value"
        href="#"
        class="text-sm-bold mod--label-option LKRoadmapsFeedLabelStatus__option"
        @click.prevent="onSelected(item)"
        v-text="item.label"
      />
    </div>
  </div>
</template>

<script>
import {
  RoadmapEventStatuses,
  RoadmapEventExpertStatuses,
  getRoadmapEventStatusesLabel,
  getRoadmapEventExpertStatusesLabel,
  getRoadmapEventStatusesLabelByRole,
  getRoadmapEventStatusesColorByRole,
  getRoadmapEventExpertStatusesColor,
} from '@/typings/api/RoadmapEvent'

import IconToggle from '@/components/lk/icons/LKIconToggle.vue'

const ADRESAT_LIST = [
  {
    value: RoadmapEventStatuses.inProgress,
    label: getRoadmapEventStatusesLabel(RoadmapEventStatuses.inProgress),
  },
  {
    value: RoadmapEventStatuses.done,
    label: getRoadmapEventStatusesLabel(RoadmapEventStatuses.done),
  },
]

const CURATOR_LIST = [
  {
    value: RoadmapEventStatuses.needsWork,
    label: getRoadmapEventStatusesLabel(RoadmapEventStatuses.needsWork),
  },
  {
    value: RoadmapEventStatuses.confirmed,
    label: getRoadmapEventStatusesLabel(RoadmapEventStatuses.done),
  },
]

export default {
  name: 'LKRoadmapsFeedLabelStatus',
  components: {
    IconToggle,
  },
  props: {
    toggle: Boolean,
    needsCheck: Boolean,
    isAdresat: Boolean,
    isCurator: Boolean,
    isExpert: Boolean,
    status: {
      type: String,
      required: true,
      validator: (prop) => Object.values(RoadmapEventStatuses).includes(prop)
        || Object.values(RoadmapEventExpertStatuses).includes(prop),
    },
  },
  data: () => ({
    isActive: false,
    isLoading: false,
  }),
  computed: {
    labelList() {
      const { isAdresat, isExpert, status } = this
      let list
      if (isAdresat) {
        list = ADRESAT_LIST
      } else if (isExpert) {
        if (
          status === RoadmapEventExpertStatuses.needsReview
          || status === null
        ) {
          list = [
            {
              value: RoadmapEventExpertStatuses.inProgress,
              label: getRoadmapEventExpertStatusesLabel(
                RoadmapEventExpertStatuses.inProgress,
              ),
            },
          ]
        } else if (status === RoadmapEventExpertStatuses.inProgress) {
          list = [
            {
              value: RoadmapEventExpertStatuses.done,
              label: getRoadmapEventExpertStatusesLabel(
                RoadmapEventExpertStatuses.done,
              ),
            },
          ]
        } else {
          list = [
            {
              value: RoadmapEventExpertStatuses.needsReview,
              label: getRoadmapEventExpertStatusesLabel(
                RoadmapEventExpertStatuses.needsReview,
              ),
            },
            {
              value: RoadmapEventExpertStatuses.inProgress,
              label: getRoadmapEventExpertStatusesLabel(
                RoadmapEventExpertStatuses.inProgress,
              ),
            },
          ]
        }
      } else {
        list = CURATOR_LIST
      }
      return list.filter((_) => _.value !== status)
    },
    label() {
      const {
        status, isAdresat, isExpert, needsCheck,
      } = this
      if (isExpert) {
        return getRoadmapEventExpertStatusesLabel(status)
      }
      return getRoadmapEventStatusesLabelByRole(status, isAdresat, needsCheck)
    },
    color() {
      const {
        status, isAdresat, isExpert, needsCheck,
      } = this
      if (isExpert) {
        return getRoadmapEventExpertStatusesColor(status)
      }
      return getRoadmapEventStatusesColorByRole(status, isAdresat, needsCheck)
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener('click', this.close)
        })
      } else {
        document.removeEventListener('click', this.close)
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
  },
  methods: {
    onSelected({ value }) {
      this.close()
      this.$emit('change', value, this.toggleLoading)
    },
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    close() {
      this.isActive = false
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedLabelStatus {
  & &__icon-toggle {
    margin: 0;
    color: $webflow-color-white;
  }

  & &__bottom {
    height: 0;
    min-height: 0;
    opacity: 0;
    transition: all 0.2s;

    &.is-active {
      height: auto;
      opacity: 1;
    }
  }

  & &__option {
    white-space: normal !important;
  }
}
</style>
